export const STYLE_GUIDE_MAX_WORDS = 3500;

// Count the saved instructions consistently in the editor and API, including
// whitespace-separated Markdown. Writing samples and controls are separate.
export function countStyleGuideWords(instructions: string = ""): number {
  return instructions.match(/\S+/gu)?.length ?? 0;
}

export function getStyleGuideWordLimit(savedInstructions: string = ""): number {
  return Math.max(STYLE_GUIDE_MAX_WORDS, countStyleGuideWords(savedInstructions));
}

export class StyleGuideWordLimitError extends Error {
  readonly code = "STYLE_GUIDE_WORD_LIMIT";

  constructor(readonly wordLimit: number) {
    super(wordLimit > STYLE_GUIDE_MAX_WORDS
      ? `This existing guide can be edited or shortened, but cannot exceed its saved length of ${wordLimit.toLocaleString("en-US")} words.`
      : "Style guides can contain up to 3,500 words. Shorten the instructions to save.");
    this.name = "StyleGuideWordLimitError";
  }
}

export function validateStyleGuideLength(instructions: string, savedInstructions: string = ""): void {
  const limit = getStyleGuideWordLimit(savedInstructions);
  if (countStyleGuideWords(instructions) > limit) throw new StyleGuideWordLimitError(limit);
}

export function styleGuideSaveErrorMessage(error: unknown, fallback = "Failed to save style. Try again."): string {
  const problem = error as { code?: string; message?: string } | null;
  return (problem?.code === "STYLE_GUIDE_WORD_LIMIT" || problem?.code === "STYLE_GUIDE_CHANGED") && problem.message
    ? problem.message
    : fallback;
}
